import React, { memo, useEffect } from 'react';
import { EditorContent, Editor } from '@tiptap/react';

interface RichTextInputProps {
  editor: Editor | null;
  placeholder?: string;
  onBlur?: () => void;
  className?: string;
}

const RichTextInputInner: React.FC<RichTextInputProps> = ({
  editor,
  placeholder = '输入内容...',
  onBlur,
  className = '',
}) => {
  useEffect(() => {
    if (editor) {
      // 提取传入 className 中的 text-* 尺寸类
      const sizeClass = className.match(/\btext-[a-z0-9\/]+\b/)?.[0] || 'text-sm';
      editor.setOptions({
        editorProps: {
          attributes: {
            class: `outline-none text-white ${sizeClass} leading-relaxed`,
          },
        },
      });
    }
  }, [editor, className]);

  if (!editor) return null;

  return (
    <div className={`w-full h-full ${className}`} onBlur={onBlur}>
      <EditorContent
        editor={editor}
        className="w-full h-full rich-text-editor"
      />
    </div>
  );
};

export const RichTextInput = memo(RichTextInputInner);
